import React, { Component, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import * as yup from 'yup'
import { get } from 'lodash'
import { FORM_PLACEHOLDERS as messages } from 'src/constants/messages'
import Button from 'src/features/buyers/Components/Button'
import styles from './AddressForm.module.scss'

const SCHEMA = yup.object().shape({
  address: yup.string().required(),
  zipcode: yup
    .number()
    .required()
    .positive()
    .integer()
})

const initErrors = () => ({
  address: false,
  zipcode: false
})

const hasErrorType = (error, type) =>
  get(error, 'inner', []).some(e => e.path === type)

const getFormValue = (e, key) => get(e, ['target', 'elements', key, 'value'])

class AddressForm extends Component {
  state = {
    errors: initErrors()
  }

  onSubmit = e => {
    e.preventDefault()

    const params = {
      address: getFormValue(e, 'address'),
      zipcode: getFormValue(e, 'zipcode')
    }

    try {
      SCHEMA.validateSync(params, { abortEarly: false })

      this.setState({ errors: initErrors() })
      this.props.fetch(params)
    } catch (err) {
      this.setState({
        errors: {
          address: hasErrorType(err, 'address'),
          zipcode: hasErrorType(err, 'zipcode')
        }
      })
    }
  }

  render () {
    const { address, zipcode, intl } = this.props
    const { errors } = this.state

    const errorStyle = key => (errors[key] ? styles.error : '')

    return (
      <Fragment>
        <h2>
          <FormattedMessage
            id='AirDna.headline.howMuchCouldYouEarn'
            defaultMessage='If you rented your future home on Airbnb, how much could you potentially earn?'
          />
        </h2>

        <form
          className={`form-v2 ${styles.inputGroup}`}
          onSubmit={this.onSubmit}
        >
          <input
            type='text'
            placeholder={intl.formatMessage(messages.address)}
            name='address'
            defaultValue={address}
            required
            className={errorStyle('address')}
          />
          <input
            type='text'
            placeholder={intl.formatMessage(messages.zip)}
            name='zipcode'
            maxLength='5'
            pattern='[0-9]{5}'
            title='Valid zip code'
            required
            defaultValue={zipcode}
            className={errorStyle('zipcode')}
          />
          <Button type='submit'>
            <FormattedMessage
              id='AirDna.address.search'
              defaultMessage='Search'
            />
          </Button>
        </form>
      </Fragment>
    )
  }
}

export default AddressForm
